import { render, staticRenderFns } from "./preguntasMultiple.vue?vue&type=template&id=7411e68a&scoped=true"
import script from "./preguntasMultiple.vue?vue&type=script&lang=js"
export * from "./preguntasMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7411e68a",
  null
  
)

export default component.exports